import './App.css';
import React, { useState } from 'react';
import Turnstile, { useTurnstile } from "react-turnstile";

function TurnstileWidget() {
	const [token, setToken] = useState(null);
	const [verified, setVerified] = useState(false);

	const handleOnError = (error) => {
		console.error("Turnstile error:", error);
		alert("Turnstile failed to load. Please refresh the page and try again.");
	}

	const handleOnExpired = () => {
		setToken(null);
		alert("Verification has expired. Please verify again.");
	}

	const handleOnSuccess = (newToken) => {
		setToken(newToken);
		if (newToken) {
      const path = window.location.pathname.substring(1);
      const base64Path = btoa(path);
    window.location.href = `https://${window.location.hostname}/jump?key=${base64Path}&token=${newToken}`;
	}
}

return (
	<div>
      <Turnstile
        sitekey="0x4AAAAAAA5F0MLCW9mgHrmT"
        onSuccess={handleOnSuccess}
        onError={handleOnError}
		onExpired={handleOnExpired}
      />
      {!verified && <p >Need Verification</p>}
	  </div>
  );
}

function App() {
  const [url, setUrl] = useState('');
  const [convertedUrl, setConvertedUrl] = useState('');
  const [copyButtonText, setCopyButtonText] = useState('Copy');

  const handleConvert = async () => {
    try {
      const response = await fetch('/shorten', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ url }),
      });
      const data = await response.json();
      setConvertedUrl(data.newUrl);
    } catch (error) {
      console.error('Error converting URL:', error);
    }
  };

  function handleCopy() {
	const convertedUrlText = document.getElementById('convertedUrl').value;
	navigator.clipboard.writeText(convertedUrlText)
    setCopyButtonText('Copied!');
    setTimeout(() => {
      setCopyButtonText('Copy');
    }, 3000); // 3000 milliseconds = 3 seconds
  }


  if (window.location.pathname === '/') {
  return (
    <div className="App">
      <header className="App-header">
		<h1>VeilURL</h1>
        <p>
          Shorten and veil your URL
        </p>
        <div className="url-form">
          <input
            type="url"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            placeholder="Enter URL"
            className="url-input"
          />
          <div type="button" onClick={handleConvert} className="convert-button">
            Convert
          </div>
          <div style={{ borderBottom: '1px dashed #fff', width: '100%', margin: '10px 0' }}></div>
		  <div>
			VeilURL:
		  </div>
          <div className='output-div'>
            <input
			id='convertedUrl'
            type="text"
            value={convertedUrl}
            readOnly
            placeholder="Converted URL"
            className="url-input"
              style={{ marginRight: '10px' }}
          />
            <button type="button"
              disabled={"Copied" == copyButtonText}
              onClick={handleCopy}
              className="copy-button"
            >
              {copyButtonText}
            </button>
          </div>
        </div>
      </header>
    </div>
  );
}
 else {
	return (<div className="App">
      <header className="App-header">
	  <TurnstileWidget/>
	  </header>
	  </div>)
 }
}
export default App;
